import { useState } from "react";
import LayoutActividad from "../../../components/LayoutActividad";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faEdit } from "@fortawesome/free-solid-svg-icons";
import { modulo12 } from "../../../routes/Module12";
import Sidebar from "../Sidebar";
import Imagen1 from "../../../images/modulo12/taxi.png";
import Card from "../../../components/Card";
import GuiaDocente from "../../../components/GuiaDocente";
import AudioPlayer from "../../../audioPlayer/AudioPlayer";
import Audio from "../../../audios/modulo12/Unidad2Actividad3.mp3";

const Actividad5 = () => {
  const [answers, setAnswers] = useState({
    ans1: { value: "", valid: "", correctValue: "niveles socioeconómicos" },
    ans2: { value: "", valid: "", correctValue: "recursos" },
    ans3: { value: "", valid: "", correctValue: "oportunidades" },
  });
  const infoUnidad = modulo12.content[1];
  const infoAct = modulo12.content[1].activities[3];
  const crumbs = [
    {
      title: modulo12.title,
      url: "/" + modulo12.url,
    },
    {
      title:
        modulo12.content.length === 1
          ? `${infoAct.name}`
          : `${infoUnidad.name} > ${infoAct.name}`,
      url: infoAct.path,
    },
  ];

  const pages = {
    titleNext: `${modulo12.content[1].name}: ${modulo12.content[1].activities[4].name}`,
    linkNext: `${modulo12.url}/${modulo12.content[1].path}/${modulo12.content[1].activities[4].path}`,
    titlePrev: `${modulo12.content[1].name}: ${modulo12.content[1].activities[2].name}`,
    linkPrev: `${modulo12.url}/${modulo12.content[1].path}/${modulo12.content[1].activities[2].path}`,
  };

  const metadata = {
    color: modulo12.color,
    title: `${modulo12.title} - ${infoAct.name}`,
    name: modulo12.title,
  };

  const validateAnswers = (event) => {
    event.preventDefault();
    let newAnswers = answers;
    Object.keys(newAnswers).forEach(
      (key) =>
        (newAnswers[key]["valid"] =
          answers[key]["correctValue"].toUpperCase() ===
          answers[key]["value"].toUpperCase()
            ? "is-valid"
            : "is-invalid")
    );
    setAnswers({ ...newAnswers });
  };
  const handleAnswers = (event, name) => {
    event.preventDefault();
    setAnswers({
      ...answers,
      [name]: { ...answers[name], value: event.target.value },
    });
  };

  return (
    <LayoutActividad
      pages={pages}
      crumbs={crumbs}
      sidebar={<Sidebar />}
      modulo={metadata}
    >
      <p>
        <small className={`c-${modulo12.color} hat-text`}>
          <FontAwesomeIcon icon={faEdit} /> Trabajamos con las palabras
        </small>
      </p>

      <h2 className="mb-5">{infoAct.name}</h2>
          <AudioPlayer track={Audio} />

      <ul>
        <li>Completa el siguiente texto con las palabras del recuadro.</li>
      </ul>

      <Card>
        <div className="d-flex justify-content-around">
          <div>recursos</div>
          <div>oportunidades</div>
          <div>niveles socioeconómicos</div>
        </div>
      </Card>

      <div className="row align-items-center">
        <div className="col-lg-6 col-12">
          <img src={Imagen1} alt="Ministra" className="img-fluid" />
        </div>
        <div className="col-lg-6 col-12">
          <p>
            Alejandrina Canchari y Walter Talancha pertenecen a distintos
            <input
              type="text"
              className={
                "form-control form-control-sm w-200 d-inline-block " +
                answers.ans1.valid
              }
              value={answers.ans1.value}
              onChange={(event) => handleAnswers(event, "ans1")}
            />
            . Eso significa que no cuentan con los mismos recursos. Por ejemplo,
            Alejandrina solo tiene dinero para transportarse en bus y combi,
            pero Walter puede pagar un taxi para ir a su trabajo todas las
            mañanas.
          </p>
          <p>
            Alejandrina nació en una familia muy pobre. Cuando cumplió 14 años,
            tuvo que dejar la escuela para ponerse a trabajar. Gracias a ese
            trabajo, consiguió que su familia tuviera más
            <input
              type="text"
              className={
                "form-control w-200 form-control-sm d-inline-block " +
                answers.ans2.valid
              }
              value={answers.ans2.value}
              onChange={(event) => handleAnswers(event, "ans2")}
            />{" "}
            para comprar alimentos y medicinas.
          </p>
          <p>
            Walter también nació en una familia pobre, pero no tuvo que dejar el
            colegio para ponerse a trabajar. Eso le permitió tener más
            <input
              type="text"
              className={
                "form-control w-200 form-control-sm d-inline-block " +
                answers.ans3.valid
              }
              value={answers.ans3.value}
              onChange={(event) => handleAnswers(event, "ans3")}
            />{" "}
            que Alejandrina. Estudió en la universidad y luego consiguió un buen
            trabajo.
          </p>
        </div>
      </div>

      <div className="row my-4">
        <div className="col-md-12">
          <button
            className={`btn float-end btn-${modulo12.color}`}
            onClick={validateAnswers}
          >
            Enviar respuestas
          </button>
        </div>
      </div>

      <GuiaDocente>
        <ul>
          <li>
            Explique a niños y niñas que en las siguientes actividades conocerán
            y emplearán nuevos términos muy útiles. Las palabras con las que
            trabajarán son “recursos”, “oportunidades”, “niveles
            socioeconómicos” y “necesidades”.
          </li>

          <li>
            Lea la primera indicación y las palabras del recuadro: Completa el
            siguiente texto con las palabras del recuadro. Pida a un niño o niña
            que lea las palabras del recuadro: recursos – oportunidades –
            niveles socioeconómicos. Explique a niños y niñas que el texto mismo
            los ayudará a comprender el significado de las palabras. Déles un
            tiempo para trabajar. Lea con niños y niñas el primer párrafo del
            texto y pregunte cuál es la palabra que falta. Ayúdelos comentando
            el texto. Por ejemplo:
            <ul>
              <li>
                <i>
                  "Aquí nos dicen que Alejandrina y Walter tienen diferentes
                  recursos. ¿Quién tendrá más recursos? Walter, porque el texto
                  nos dice que puede pagar su taxi todas las mañanas, mientras
                  que Alejandrina usa el bus que es más barato. Eso quiere decir
                  que pertenecen a distintos “niveles socioeconómicos”. En
                  efecto, los niveles socioeconómicos se determinan sobre la
                  base de los ingresos, la educación y la ocupación de las
                  personas”.
                </i>
              </li>
            </ul>
          </li>

          <li>
            Lea con niños y niñas el siguiente párrafo del texto y pregunte cuál
            es la palabra que falta. Por ejemplo:
            <ul>
              <li>
                <i>
                  “En este párrafo, el texto nos sugiere que la palabra faltante
                  nos sirve “para comprar alimentos y medicinas”, ¿a qué palabra
                  se referirá?”. La palabra que falta es “recursos”, que se
                  refiere al conjunto de elementos disponibles para resolver una
                  necesidad. En algunos casos, como en el texto, se utiliza como
                  sinónimo de medios económicos o dinero”.
                </i>
              </li>
            </ul>
          </li>

          <li>
            Finalmente, lea el párrafo final y pregunte cuál es la palabra que
            falta. Por ejemplo:
            <ul>
              <li>
                <i>
                  “En este párrafo, la palabra que falta está relacionada con
                  que Walter pudo ir a la escuela y ello le permitió luego ir a
                  la universidad y conseguir un buen trabajo, ¿ qué palabra
                  será? La palabra faltante es “oportunidades”. En este
                  contexto, las oportunidades se refieren a las circunstancias
                  que hacen que tengamos posibilidades de lograr mejoras en
                  nuestra vida”.
                </i>
              </li>
            </ul>
          </li>

          <li>
            Una vez que hayan completado todas las palabras, lean todo el texto
            una vez más. Confirme que niños y niñas han comprendido las palabras
            a partir de preguntas
          </li>
        </ul>
      </GuiaDocente>
    </LayoutActividad>
  );
};

export default Actividad5;
